import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Handshake, Fuel, Pill, Dumbbell, Eye, Stethoscope, Store } from 'lucide-react';
import api from '../../services/api';

const iconePorTipo = {
  'Posto de Combustível': Fuel,
  'Farmácia': Pill,
  'Ginásio': Dumbbell,
  'Óptica': Eye,
  'Clínica': Stethoscope,
};

const InfoParceriasAtivas = ({ user }) => {
  const [parcerias, setParcerias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadParcerias();
  }, []);

  const loadParcerias = async () => {
    try {
      const resp = await api.get('/parcerias/entidades?estado=true');
      setParcerias(resp.data);
    } catch (error) {
      console.error('Erro ao carregar parcerias:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatRegra = (regra) => {
    const tipo = regra.tipo_beneficio;
    if (tipo === '€/Litro') {
      return `€${regra.valor_beneficio}/litro${regra.limite_litros ? ` (máx ${regra.limite_litros}L)` : ''}`;
    } else if (tipo === 'Percentagem') {
      return `${regra.valor_beneficio}%`;
    }
    return `€${regra.valor_beneficio}`;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="info-parcerias-ativas">
      <p className="text-sm text-muted-foreground">
        Parcerias ativas e respetivas regras de desconto
      </p>

      {parcerias.length === 0 ? (
        <Card>
          <CardContent className="py-8 text-center text-muted-foreground">
            Nenhuma parceria ativa
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {parcerias.map(p => {
            const Icon = iconePorTipo[p.tipo_entidade] || Store;
            return (
              <Card key={p.id} data-testid={`parceria-card-${p.id}`}>
                <CardHeader className="pb-2">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-primary/10 rounded-lg">
                      <Icon className="h-5 w-5 text-primary" />
                    </div>
                    <div>
                      <CardTitle className="text-base">{p.nome_entidade}</CardTitle>
                      <p className="text-xs text-muted-foreground">{p.tipo_entidade}</p>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="space-y-3">
                  {p.objetivo_parceria && (
                    <p className="text-sm text-muted-foreground">{p.objetivo_parceria}</p>
                  )}
                  
                  <div className="space-y-1.5">
                    {(p.regras_desconto || []).map((regra, i) => (
                      <div key={i} className="flex items-center justify-between p-2 bg-green-50 rounded text-sm">
                        <span>Compra min: <strong>€{regra.valor_minimo_compra}</strong></span>
                        <Badge variant="outline" className="font-mono">
                          {formatRegra(regra)}
                        </Badge>
                      </div>
                    ))}
                  </div>

                  <div className="flex items-center justify-between text-xs text-muted-foreground pt-1 border-t">
                    <span>Validade: {p.dias_validade_padrao} dias</span>
                    <span>Modelo: {p.modelo_parceria}</span>
                  </div>
                  {p.bloqueia_se_vale_ativo && (
                    <p className="text-xs text-amber-600">Bloqueia se vale ativo</p>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default InfoParceriasAtivas;
